export const PowerIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.16247 8.96358L8.97555 2.94723C9.05939 2.84243 9.22698 2.92543 9.19442 3.05564L8.03883 7.67802C8.01911 7.75691 8.07878 7.83333 8.1601 7.83333H11.7399C11.8447 7.83333 11.903 7.95458 11.8375 8.03642L7.02445 14.0528C6.94061 14.1576 6.77302 14.0746 6.80558 13.9444L7.96117 9.32198C7.98089 9.24309 7.92122 9.16667 7.8399 9.16667H4.26008C4.15526 9.16667 4.09699 9.04543 4.16247 8.96358Z"
            fill="#181A1C"
        />
    </svg>
);
